export const common = {
  black: '#000',
  white: '#fff',
};
